import { useEffect, useState } from 'react'
import { api } from '../../api/client'

const money = (value: number) => value.toLocaleString(undefined, { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 6 })
const categories: Record<string, string> = { generation: 'Generation', browser: 'Browser', voice: 'Voice', research: 'Research', email: 'Email', infrastructure: 'Infrastructure', unclassified: 'Unclassified' }

export default function SpendUseCases() {
  const [data, setData] = useState<Awaited<ReturnType<typeof api.spendUseCases>> | null>(null)
  const [error, setError] = useState('')
  const [refresh, setRefresh] = useState(0)
  useEffect(() => {
    let live = true
    let timer: ReturnType<typeof setTimeout> | undefined
    async function poll() {
      try {
        const result = await api.spendUseCases()
        if (live) { setData(result); setError('') }
      } catch (e) { if (live) setError(e instanceof Error ? e.message : 'Could not load spend by use case.') }
      finally { if (live) timer = setTimeout(() => { void poll() }, 10000) }
    }
    void poll()
    return () => { live = false; clearTimeout(timer) }
  }, [refresh])
  return <section className="panel">
    <h2>Spend by use case</h2>
    <p className="muted">See what browser sessions, generation, voice, and other services were used for.</p>
    {error && <div className="notice crit" role="alert">{error} <button className="btn small secondary" onClick={() => setRefresh(value => value + 1)}>Retry</button></div>}
    {!data ? <p className="muted">{error ? 'Spend breakdown is unavailable.' : 'Loading breakdown…'}</p> : <>
      <div className="table-wrap"><table className="data"><thead><tr><th>Area</th><th>Use case</th><th>Service</th><th>Confirmed</th><th>Estimated</th><th>Reserved</th><th>Total exposure</th><th>Events</th></tr></thead><tbody>
        {data.rows.map(row => <tr key={`${row.category}:${row.use_case}:${row.service}`}><td>{categories[row.category] ?? row.category}</td><td className="wrap">{row.use_case}</td><td>{row.service.replace(/_/g, ' ')}</td><td>{money(row.actual_usd)}</td><td>{money(row.estimated_usd)}</td><td>{money(row.reserved_usd)}</td><td>{money(row.committed_usd)}</td><td>{row.events}{row.unpriced_events > 0 && <p className="muted">{row.unpriced_events} awaiting pricing</p>}</td></tr>)}
        {!data.rows.length && <tr><td colSpan={8}>No costs recorded yet.</td></tr>}
      </tbody><tfoot><tr><th colSpan={3}>All use cases</th><td>{money(data.totals.actual_usd)}</td><td>{money(data.totals.estimated_usd)}</td><td>{money(data.totals.reserved_usd)}</td><td>{money(data.totals.committed_usd)}</td><td>{data.totals.events}</td></tr></tfoot></table></div>
      <div className="table-footnote"><span>Each event is counted once. Estimates and reservations are not confirmed charges.</span><details><summary>How amounts are tracked</summary><p>{data.note}</p></details></div>
    </>}
  </section>
}
